// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"54292a4b","591":"00a4d25a","974":"8c441662"}[chunkId] + ".chunk.js";
};